var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['answer-input-box', { flexCenter: _vm.center }]},_vm._l((_vm.textArr),function(item,index){return _c('div',{key:index,class:[
      'input-item',
      {
        success: _vm.blankType === 'success',
      },
      {
        error: _vm.blankType === 'error',
      },
    ],on:{"click":function($event){return _vm.clickItem(index, item)}}},[(_vm.textType === 'string')?_c('div',{staticClass:"input-item-text"},[_vm._v(" "+_vm._s(item.text)+" ")]):(item.text)?_c('PhoneticText',{attrs:{"showPinyin":true,"originData":item.text,"baseStyles":_vm.baseStyles}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }